import { TileLayer } from "react-leaflet";

const API_BASE = (process.env.REACT_APP_URL_API ?? "http://localhost:8000/").replace(/\/$/, "");

interface FilteredRasterLayerProps {
  layerKey: string;
  minVal?: number;
  maxVal?: number;
  /** Bounding box of the selected area [west, south, east, north] in WGS-84.
   *  When provided the backend skips tiles outside the box and uses a
   *  pre-clipped raster, making rendering significantly faster. */
  bbox?: [number, number, number, number];
  opacity?: number;
  zIndex?: number;
}

export function FilteredRasterLayer({
  layerKey,
  minVal,
  maxVal,
  bbox,
  opacity = 0.8,
  zIndex = 500,
}: FilteredRasterLayerProps) {
  const params = new URLSearchParams();
  if (minVal !== undefined) params.set("min_val", String(minVal));
  if (maxVal !== undefined) params.set("max_val", String(maxVal));
  if (bbox !== undefined) params.set("bbox", bbox.map((v) => v.toFixed(5)).join(","));
  const qs = params.toString();

  const tileUrl = `${API_BASE}/api/v1/tiles/${layerKey}/{z}/{x}/{y}.png${qs ? `?${qs}` : ""}`;

  return (
    <TileLayer
      key={tileUrl}
      url={tileUrl}
      opacity={opacity}
      zIndex={zIndex}
      tms={false}
    />
  );
}
